<template>
  <div>
    <Header :title="$t('account.title')" />
    <div
      class="full-page-box"
      style="background-color: rgb(248 249 250); min-height: calc(100vh)"
    >
      <div class="item-box">
        <img src="../../assets/imgs/account/top.png" />
      </div>
      <div class="item-box">
        <van-cell-group>
          <van-cell @click="topage('profile')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="User"><g><path d="M17.438,21.937H6.562a2.5,2.5,0,0,1-2.5-2.5V18.61c0-3.969,3.561-7.2,7.938-7.2s7.938,3.229,7.938,7.2v.827A2.5,2.5,0,0,1,17.438,21.937ZM12,12.412c-3.826,0-6.938,2.78-6.938,6.2v.827a1.5,1.5,0,0,0,1.5,1.5H17.438a1.5,1.5,0,0,0,1.5-1.5V18.61C18.938,15.192,15.826,12.412,12,12.412Z"></path><path d="M12,9.911a3.924,3.924,0,1,1,3.923-3.924A3.927,3.927,0,0,1,12,9.911Zm0-6.847a2.924,2.924,0,1,0,2.923,2.923A2.926,2.926,0,0,0,12,3.064Z"></path></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu1') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box">
        <van-cell-group>
          <van-cell @click="topage('loan')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Wallet"><g><path d="M19.435,4.065H4.565a2.5,2.5,0,0,0-2.5,2.5v10.87a2.5,2.5,0,0,0,2.5,2.5h14.87a2.5,2.5,0,0,0,2.5-2.5V6.565A2.5,2.5,0,0,0,19.435,4.065Zm1.5,9.93h-6.42a2,2,0,0,1,0-4h6.42Zm-6.42-5a3,3,0,0,0,0,6h6.42v2.44a1.5,1.5,0,0,1-1.5,1.5H4.565a1.5,1.5,0,0,1-1.5-1.5V6.565a1.5,1.5,0,0,1,1.5-1.5h14.87a1.5,1.5,0,0,1,1.5,1.5v2.43Z"></path><circle cx="14.519" cy="11.996" r="1"></circle></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu2') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box">
        <van-cell-group>
          <van-cell @click="topage('withdrawrecord')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Wallet"><g><path d="M19.435,4.065H4.565a2.5,2.5,0,0,0-2.5,2.5v10.87a2.5,2.5,0,0,0,2.5,2.5h14.87a2.5,2.5,0,0,0,2.5-2.5V6.565A2.5,2.5,0,0,0,19.435,4.065Zm1.5,9.93h-6.42a2,2,0,0,1,0-4h6.42Zm-6.42-5a3,3,0,0,0,0,6h6.42v2.44a1.5,1.5,0,0,1-1.5,1.5H4.565a1.5,1.5,0,0,1-1.5-1.5V6.565a1.5,1.5,0,0,1,1.5-1.5h14.87a1.5,1.5,0,0,1,1.5,1.5v2.43Z"></path><circle cx="14.519" cy="11.996" r="1"></circle></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu6') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box">
        <van-cell-group>
          <van-cell @click="topage('change-password')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Lock"><g><path d="M17.44,9.33h-1.1V6.4a4.34,4.34,0,0,0-8.68,0V9.33H6.56a2.5,2.5,0,0,0-2.5,2.5v7.61a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.83A2.5,2.5,0,0,0,17.44,9.33ZM8.66,6.4a3.34,3.34,0,0,1,6.68,0V9.33H8.66ZM18.94,19.44a1.511,1.511,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.83a1.5,1.5,0,0,1,1.5-1.5H17.44a1.5,1.5,0,0,1,1.5,1.5Z"></path><path d="M13,14.95a.984.984,0,0,1-.5.86v1.5a.5.5,0,0,1-1,0v-1.5a.984.984,0,0,1-.5-.86,1,1,0,0,1,2,0Z"></path></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu3') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box" v-show="!(usrdata.paypassword && usrdata.paypassword.length > 0)">
        <van-cell-group>
          <van-cell @click="topage('changepaypwd')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Lock"><g><path d="M17.44,9.33h-1.1V6.4a4.34,4.34,0,0,0-8.68,0V9.33H6.56a2.5,2.5,0,0,0-2.5,2.5v7.61a2.507,2.507,0,0,0,2.5,2.5H17.44a2.507,2.507,0,0,0,2.5-2.5V11.83A2.5,2.5,0,0,0,17.44,9.33ZM8.66,6.4a3.34,3.34,0,0,1,6.68,0V9.33H8.66ZM18.94,19.44a1.511,1.511,0,0,1-1.5,1.5H6.56a1.511,1.511,0,0,1-1.5-1.5V11.83a1.5,1.5,0,0,1,1.5-1.5H17.44a1.5,1.5,0,0,1,1.5,1.5Z"></path><path d="M13,14.95a.984.984,0,0,1-.5.86v1.5a.5.5,0,0,1-1,0v-1.5a.984.984,0,0,1-.5-.86,1,1,0,0,1,2,0Z"></path></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu5') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box">
        <van-cell-group>
          <van-cell @click="topage('contract')">
            <template #icon>
                <span class="icon-item"><svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><g id="Wallet"><g><path d="M19.435,4.065H4.565a2.5,2.5,0,0,0-2.5,2.5v10.87a2.5,2.5,0,0,0,2.5,2.5h14.87a2.5,2.5,0,0,0,2.5-2.5V6.565A2.5,2.5,0,0,0,19.435,4.065Zm1.5,9.93h-6.42a2,2,0,0,1,0-4h6.42Zm-6.42-5a3,3,0,0,0,0,6h6.42v2.44a1.5,1.5,0,0,1-1.5,1.5H4.565a1.5,1.5,0,0,1-1.5-1.5V6.565a1.5,1.5,0,0,1,1.5-1.5h14.87a1.5,1.5,0,0,1,1.5,1.5v2.43Z"></path><circle cx="14.519" cy="11.996" r="1"></circle></g></g></svg></span>
            </template>
            <template #title>
                <div class="icon-item-text ">{{ $t('account.menu4') }}</div>
            </template>
            <template #right-icon>
                <van-icon name="arrow" style="margin-top: 8px;" />
            </template>
          </van-cell>
        </van-cell-group>
      </div>
      <div class="item-box">
        <van-button @click="logout" class="logout-btn">{{ $t('account.logout') }}</van-button>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import { Toast } from "vant";
import Footer from "@/components/footer/index.vue";
import Header from "@/components/header/index.vue";
export default {
  name: "AccountView",
  components: { Footer, Header },
  data(){
    return {
      usrdata:{}
    }
  },
  created(){
    if(!localStorage.getItem('token')){
      this.$router.push({ name: 'login' });
    } else {
      this.getInfo()
    }
  },
  methods: {
    logout(){
        localStorage.clear()
        this.$router.push({ name: 'login' });
    },
    topage(val){
        this.$router.push({ name: val }); 
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data
          }
        } else {
          Toast(res.msg);
        }
      });
    },
  }
};
</script>
<style scoped>
.item-box {
  width: 96%;
  margin: 10px auto;
}
.item-box img {
  width: 100%;
  border-radius: 8px;
}
.icon-item {
    background-color: rgba(31,118,185,.2);
    border-radius: 9999px;
    color: rgb(4 109 181);
    font-size: 18px;
    padding: 5px 8px;
    line-height: 1;
}
.icon-item-text {
    line-height: 2.2;margin-left: 5px;
}
.logout-btn {
    color: rgb(4 109 181);
    border-radius: 8px;
    border: 1px solid rgb(4 109 181);
    width: 100%;
}
</style>
